<template>
  <v-container fluid class="ranking-vendedora pa-4">
    <Alerta v-if="respuestaAlerta" :parametros="parametros" @cierra="respuestaAlerta = false" />
    <carga v-if="cargar" />

    <v-row justify="center">
      <v-col cols="12" lg="10" xl="8">
        <div class="ranking-panel shadowCard">
        <!-- Encabezado -->
        <v-card class="ranking-hero" elevation="0" flat>
          <v-card-text class="pa-4 pa-sm-5 ranking-hero__body">
            <v-btn
              icon
              small
              color="primary"
              class="ranking-hero__refresh"
              :loading="cargar"
              @click="refrescarTodo()"
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

            <div class="ranking-hero__center text-center">
              <v-avatar size="56" class="ranking-hero__avatar mb-3">
                <v-icon color="white" size="30">mdi-trophy-variant</v-icon>
              </v-avatar>
              <h1 class="ranking-hero__title mb-0">Ranking de Vendedoras</h1>
            </div>

            <div class="ranking-hero__ciclo-block text-center mt-4">
              <div class="ranking-marca">
                <button
                  type="button"
                  class="ranking-marca__btn"
                  :class="{ 'ranking-marca__btn--activo': marca === 'inbi' }"
                  @click="cambiarMarca('inbi')"
                >
                  INBI
                </button>
                <span class="ranking-marca__sep">|</span>
                <button
                  type="button"
                  class="ranking-marca__btn"
                  :class="{ 'ranking-marca__btn--activo': marca === 'fast' }"
                  @click="cambiarMarca('fast')"
                >
                  FAST
                </button>
              </div>

              <div v-if="ciclo" class="ranking-hero__ciclo-row mt-2">
              <v-chip
                label
                small
                color="primary"
                dark
                class="ranking-hero__ciclo-chip"
              >
                <v-icon left x-small>mdi-calendar-star</v-icon>
                {{ ciclo }}
              </v-chip>
              <v-chip
                v-if="miEntradaRanking"
                label
                small
                outlined
                color="primary"
                class="ranking-hero__posicion-chip ml-2"
              >
                <v-icon left x-small>mdi-account-star</v-icon>
                Tu posición: #{{ miEntradaRanking.ranking }}
              </v-chip>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Podio top 3 -->
        <v-row v-if="topTres.length" class="ranking-panel__podio px-2 px-sm-3 mb-4" align="end" justify="center">
          <v-col
            v-for="item in topTresOrdenado"
            :key="'podio-' + item.id_usuario"
            cols="4"
            sm="3"
            class="text-center"
          >
            <div
              class="ranking-podio"
              :class="[
                'ranking-podio--' + item.ranking,
                { 'ranking-podio--yo': esYo(item) },
              ]"
            >
              <div class="ranking-podio__num">{{ item.ranking }}</div>
              <div class="ranking-podio__nombre" :class="claseNombre(item.ranking)">
                {{ item.nombre_completo }}
                <span v-if="esYo(item)" class="ranking-yo-badge">Tú</span>
              </div>
              <div class="ranking-podio__plantel">{{ item.plantel }}</div>
              <div class="ranking-podio__ventas">{{ item.completos }} inscritos</div>
              <v-chip
                small
                class="mt-2 ranking-estatus-chip ranking-estatus-chip--solo-lectura"
                :color="colorEstatus(item.estatus)"
                :text-color="textoEstatus(item.estatus)"
              >
                <v-icon left x-small>{{ iconoEstatus(item.estatus) }}</v-icon>
                {{ item.estatus }}
              </v-chip>
            </div>
          </v-col>
        </v-row>

        <!-- Lista completa -->
        <div class="ranking-lista px-2 px-sm-3 pb-2">
          <div
            v-for="item in rankingConEstatus"
            :key="filaKey(item)"
            class="ranking-fila"
            :class="{
              'ranking-fila--top1': item.ranking === 1,
              'ranking-fila--top2': item.ranking === 2,
              'ranking-fila--top3': item.ranking === 3,
              'ranking-fila--yo': esYo(item),
            }"
          >
            <div class="ranking-fila__numero" :class="claseNumero(item.ranking)">
              {{ item.ranking }}
            </div>

            <div class="ranking-fila__info flex-grow-1">
              <div class="ranking-fila__nombre" :class="claseNombre(item.ranking)">
                {{ item.nombre_completo }}
                <span v-if="esYo(item)" class="ranking-yo-badge">Tú</span>
              </div>
              <div class="ranking-fila__plantel">
                <v-icon x-small class="mr-1" color="primary">mdi-map-marker</v-icon>
                {{ item.plantel }}
              </div>
            </div>

            <div class="ranking-fila__ventas text-center mx-3 d-none d-sm-block">
              <div class="ranking-fila__ventas-num">{{ item.completos }}</div>
              <div class="ranking-fila__ventas-label">inscritos</div>
            </div>

            <v-chip
              small
              rounded
              class="ranking-estatus-btn ranking-estatus-chip--solo-lectura"
              :color="colorEstatus(item.estatus)"
              :text-color="textoEstatus(item.estatus)"
            >
              <v-icon left x-small>{{ iconoEstatus(item.estatus) }}</v-icon>
              {{ item.estatus }}
            </v-chip>
          </div>
        </div>

        <!-- Cierre inferior (misma línea azul que el encabezado) -->
        <div v-if="ranking.length" class="ranking-panel__pie">
          <div class="ranking-panel__pie-fill" />
          <div class="ranking-panel__pie-line" />
        </div>
        </div>

        <v-alert
          v-if="!cargar && ranking.length === 0"
          type="info"
          text
          class="mt-4 shadowCard"
        >
          No hay vendedoras activas para mostrar.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';
import {
  colorEstatusVendedora,
  textoEstatusVendedora,
  iconoEstatusVendedora,
  estatusRecepcionDeMap,
} from '@/utils/estatusVendedoraRanking';

/** Ciclo de venta: misma regla que Ventas al momento (semana 1 = actual, desde día 8 = siguiente). */
export default {
  name: 'RankingVendedora',

  components: { Alerta, carga },

  mixins: [validarErrores],

  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargar: false,
    ciclo: '',
    fechaInicioCiclo: null,
    fechaFinCiclo: null,
    ranking: [],
    marca: 'inbi',
    intervaloActualizacion: null,
    intervaloEstatus: null,
    consultaEnCurso: false,
  }),

  computed: {
    ...mapGetters('login', [
      'getdatosUsuarioERPERP',
      'getEstatusRecepcionMap',
      'getEstatusRecepcionVersion',
    ]),

    rankingConEstatus() {
      void this.getEstatusRecepcionVersion;
      const map = this.getEstatusRecepcionMap;
      return this.ranking.map((item) => ({
        ...item,
        estatus: estatusRecepcionDeMap(map, item.id_usuario),
      }));
    },

    topTres() {
      return this.rankingConEstatus.filter((v) => v.ranking <= 3);
    },

    /** Podio visual: 2 - 1 - 3 */
    topTresOrdenado() {
      const t = this.topTres;
      if (t.length < 3) return t;
      const map = {};
      t.forEach((v) => { map[v.ranking] = v; });
      return [map[2], map[1], map[3]].filter(Boolean);
    },

    miIdUsuario() {
      const id = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp;
      return id != null ? Number(id) : null;
    },

    miEntradaRanking() {
      if (this.miIdUsuario == null) return null;
      return this.rankingConEstatus.find((v) => Number(v.id_usuario) === this.miIdUsuario) || null;
    },

    escuelaConsulta() {
      return this.marca === 'fast' ? 2 : 1;
    },
  },

  async created() {
    await this.consultar();
    this.$store.dispatch('login/cargarEstatusRecepcionMap').catch(() => {});
    this.intervaloActualizacion = setInterval(() => {
      this.consultar(true);
    }, 60 * 60 * 1000);
    this.intervaloEstatus = setInterval(() => {
      this.$store.dispatch('login/cargarEstatusRecepcionMap').catch(() => {});
    }, 5000);
  },

  watch: {
    getEstatusRecepcionVersion() {
      // Forzar recálculo del podio cuando otro usuario cambia estatus
      this.$forceUpdate();
    },
  },

  beforeDestroy() {
    if (this.intervaloActualizacion) {
      clearInterval(this.intervaloActualizacion);
    }
    if (this.intervaloEstatus) {
      clearInterval(this.intervaloEstatus);
    }
  },

  methods: {
    /** Datos de prueba para visualizar UI cuando no hay vendedoras activas en BD. */
    rankingDemo(escuela) {
      const baseInbi = [
        { id_usuario: 9001, nombre_completo: 'Ana López Martínez', plantel: 'San Miguel', completos: 28, escuela: 1 },
        { id_usuario: 9002, nombre_completo: 'María Fernanda Ruiz', plantel: 'Pablo Livas', completos: 24, escuela: 1 },
        { id_usuario: 9003, nombre_completo: 'Carol Williams', plantel: 'Fresnos', completos: 21, escuela: 1 },
        { id_usuario: 9004, nombre_completo: 'Laura Gómez Díaz', plantel: 'Linda Vista', completos: 17, escuela: 1 },
        { id_usuario: 9005, nombre_completo: 'Sofía Hernández Cruz', plantel: 'Casa Blanca', completos: 12, escuela: 1 },
      ];
      const baseFast = [
        { id_usuario: 9101, nombre_completo: 'Patricia Morales', plantel: 'Fast Apodaca', completos: 31, escuela: 2 },
        { id_usuario: 9102, nombre_completo: 'Daniela Castillo', plantel: 'Noria', completos: 26, escuela: 2 },
        { id_usuario: 9103, nombre_completo: 'Valeria Méndez', plantel: 'Fast LV', completos: 22, escuela: 2 },
        { id_usuario: 9104, nombre_completo: 'Andrea Vargas', plantel: 'Eloy Cavazos', completos: 18, escuela: 2 },
        { id_usuario: 9105, nombre_completo: 'Camila Ortega', plantel: 'Fast UNI', completos: 14, escuela: 2 },
      ];
      const base = Number(escuela) === 2 ? baseFast : baseInbi;
      return base.map((v, i) => ({ ...v, ranking: i + 1 }));
    },

    cambiarMarca(marca) {
      if (this.marca === marca) return;
      this.marca = marca;
      this.refrescarTodo();
    },

    refrescarTodo() {
      this.consultar();
      this.$store.dispatch('login/cargarEstatusRecepcionMap');
    },

    async consultar(silencioso = false) {
      if (this.consultaEnCurso) return;
      this.consultaEnCurso = true;
      if (!silencioso) this.cargar = true;
      try {
        // Sin id_ciclo: el API resuelve con cicloActualActivoVentas2 (igual que Ventas al momento)
        const res = await this.$http.post('kpi.ranking.vendedoras', {
          escuela: this.escuelaConsulta,
        });

        this.ciclo = res.data.ciclo || '';
        this.fechaInicioCiclo = res.data.fecha_inicio_ciclo;
        this.fechaFinCiclo = res.data.fecha_fin_ciclo;
        let lista = res.data.ranking || [];

        // Demo: 5 registros si no hay vendedoras activas (para visualizar la vista)
        if (!lista.length) {
          lista = this.rankingDemo(this.escuelaConsulta);
          if (!this.ciclo) this.ciclo = 'CICLO (demo)';
        }

        this.ranking = lista;
        if (this.miEntradaRanking) {
          this.$nextTick(() => this.scrollAMiPosicion());
        }
      } catch (error) {
        // Si falla el API, igual mostramos demo para poder visualizar
        this.ranking = this.rankingDemo(this.escuelaConsulta);
        if (!this.ciclo) this.ciclo = 'CICLO (demo)';
        if (!silencioso) {
          this.validarError(error.response ? error.response.data.message : 'Error al consultar');
        }
      } finally {
        this.consultaEnCurso = false;
        if (!silencioso) this.cargar = false;
      }
    },

    filaKey(item) {
      return `${item.id_usuario}-${this.getEstatusRecepcionVersion}-${item.estatus}`;
    },

    esYo(item) {
      if (this.miIdUsuario == null || !item) return false;
      return Number(item.id_usuario) === this.miIdUsuario;
    },

    scrollAMiPosicion() {
      const el = this.$el.querySelector('.ranking-fila--yo');
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },

    claseNombre(ranking) {
      if (ranking === 1) return 'ranking-nombre--1';
      if (ranking === 2) return 'ranking-nombre--2';
      if (ranking === 3) return 'ranking-nombre--3';
      return 'ranking-nombre--resto';
    },

    claseNumero(ranking) {
      if (ranking === 1) return 'ranking-num--1';
      if (ranking === 2) return 'ranking-num--2';
      if (ranking === 3) return 'ranking-num--3';
      return 'ranking-num--resto';
    },

    colorEstatus(estatus) {
      return colorEstatusVendedora(estatus);
    },

    textoEstatus(estatus) {
      return textoEstatusVendedora(estatus);
    },

    iconoEstatus(estatus) {
      return iconoEstatusVendedora(estatus);
    },
  },
};
</script>

<style scoped>
.ranking-vendedora {
  min-height: 100vh;
  background: #ffffff;
}

/* Contenedor tipo tabla completa */
.ranking-panel {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(30, 136, 229, 0.12);
  background: #ffffff;
  margin-bottom: 1.5rem;
}

.ranking-panel__podio {
  padding-top: 0.5rem;
}

.ranking-panel__pie {
  border-radius: 0 0 14px 14px;
  overflow: hidden;
}

.ranking-panel__pie-fill {
  height: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #e3f2fd 100%);
}

.ranking-panel__pie-line {
  height: 4px;
  background: #1E88E5;
}

/* Hero card — azul primary de la app (#1E88E5) */
.ranking-hero {
  border-radius: 0 !important;
  border-top: 4px solid #1E88E5;
  border-bottom: 1px solid rgba(30, 136, 229, 0.1);
  background: linear-gradient(180deg, #e3f2fd 0%, #ffffff 45%, #ffffff 100%);
  overflow: hidden;
  position: relative;
  box-shadow: none !important;
}

.ranking-hero__body {
  position: relative;
}

.ranking-hero__refresh {
  position: absolute !important;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.ranking-hero__center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 0.25rem;
}

.ranking-hero__avatar {
  background: linear-gradient(135deg, #42a5f5 0%, #1E88E5 100%) !important;
  box-shadow: 0 4px 14px rgba(30, 136, 229, 0.35);
}

.ranking-hero__title {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #1565C0;
  line-height: 1.25;
}

@media (min-width: 600px) {
  .ranking-hero__title {
    font-size: 1.85rem;
  }
}

.ranking-hero__ciclo-chip,
.ranking-hero__posicion-chip {
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-left: 0 !important;
}

.ranking-hero__ciclo-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ranking-hero__ciclo-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.ranking-marca {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  user-select: none;
  padding: 4px 6px;
  border-radius: 999px;
  background: rgba(30, 136, 229, 0.06);
  border: 1px solid rgba(30, 136, 229, 0.12);
}

.ranking-marca__btn {
  border: none;
  background: transparent;
  padding: 5px 14px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: rgba(21, 101, 192, 0.45);
  cursor: pointer;
  border-radius: 999px;
  transition: color 0.15s ease, background 0.15s ease;
}

.ranking-marca__btn:hover {
  color: rgba(21, 101, 192, 0.75);
}

.ranking-marca__btn--activo {
  color: #fff;
  background: #1E88E5;
}

.ranking-marca__sep {
  color: rgba(21, 101, 192, 0.25);
  font-size: 0.75rem;
  font-weight: 300;
  padding: 0 2px;
}

.ranking-yo-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  background: #1E88E5;
  border-radius: 4px;
  vertical-align: middle;
}

/* Podio */
.ranking-podio {
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 1rem 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.28s ease, box-shadow 0.28s ease;
  transform-origin: center bottom;
  cursor: default;
}

.ranking-podio:hover {
  transform: scale(1.08);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 2;
  position: relative;
}

.ranking-podio--1 {
  border-color: rgba(255, 193, 7, 0.55);
  box-shadow: 0 4px 16px rgba(255, 193, 7, 0.2);
  background: linear-gradient(180deg, #fffde7 0%, #fafafa 100%);
  transform: scale(1.05);
  margin-bottom: 0;
}

.ranking-podio--1:hover {
  transform: scale(1.14);
  box-shadow: 0 10px 28px rgba(255, 193, 7, 0.28);
}

.ranking-podio--2 {
  border-color: rgba(158, 158, 158, 0.45);
  background: linear-gradient(180deg, #f5f5f5 0%, #fafafa 100%);
  margin-bottom: 12px;
}

.ranking-podio--3 {
  border-color: rgba(205, 127, 50, 0.45);
  background: linear-gradient(180deg, #fff8e1 0%, #fafafa 100%);
  margin-bottom: 6px;
}

.ranking-podio--yo {
  border-color: #1E88E5 !important;
  box-shadow: 0 4px 18px rgba(30, 136, 229, 0.35) !important;
  background: linear-gradient(180deg, #e3f2fd 0%, #fafafa 100%) !important;
}

.ranking-podio__num {
  font-size: 2rem;
  font-weight: 800;
  color: #546e7a;
  line-height: 1;
}

.ranking-podio--1 .ranking-podio__num { color: #f9a825; }
.ranking-podio--2 .ranking-podio__num { color: #9e9e9e; }
.ranking-podio--3 .ranking-podio__num { color: #cd7f32; }

.ranking-podio__nombre {
  margin-top: 0.5rem;
  color: #263238;
  line-height: 1.2;
  word-break: break-word;
}

.ranking-podio__plantel {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}

.ranking-podio__ventas {
  font-size: 0.8rem;
  color: #1E88E5;
  margin-top: 4px;
  font-weight: 600;
}

/* Nombres por posición */
.ranking-nombre--1 { font-size: 1.35rem; font-weight: 700; color: #263238; }
.ranking-nombre--2 { font-size: 1.15rem; font-weight: 600; color: #37474f; }
.ranking-nombre--3 { font-size: 1rem; font-weight: 600; color: #37474f; }
.ranking-nombre--resto { font-size: 0.95rem; font-weight: 500; color: #455a64; }

/* Lista */
.ranking-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ranking-fila {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.ranking-fila:hover {
  border-color: rgba(0, 0, 0, 0.14);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.ranking-fila--top1 {
  border-color: rgba(255, 193, 7, 0.45);
  background: #fffde7;
}

.ranking-fila--top2 {
  border-color: rgba(158, 158, 158, 0.35);
  background: #f5f5f5;
}

.ranking-fila--top3 {
  border-color: rgba(205, 127, 50, 0.35);
  background: #fff8e1;
}

.ranking-fila--yo {
  border-color: #1E88E5 !important;
  background: linear-gradient(90deg, rgba(30, 136, 229, 0.14) 0%, rgba(30, 136, 229, 0.05) 100%) !important;
  box-shadow: 0 0 0 2px rgba(30, 136, 229, 0.28), 0 2px 8px rgba(30, 136, 229, 0.12);
}

.ranking-fila__numero {
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-weight: 800;
  font-size: 1.25rem;
  background: #e3f2fd;
  color: #1E88E5;
  flex-shrink: 0;
}

.ranking-num--1 { background: rgba(255, 193, 7, 0.25); color: #f9a825; font-size: 1.5rem; }
.ranking-num--2 { background: rgba(158, 158, 158, 0.2); color: #757575; font-size: 1.35rem; }
.ranking-num--3 { background: rgba(205, 127, 50, 0.2); color: #cd7f32; font-size: 1.2rem; }
.ranking-num--resto { font-size: 1rem; }

.ranking-fila__nombre {
  color: #263238;
  line-height: 1.25;
}

.ranking-fila__plantel {
  font-size: 0.78rem;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 2px;
}

.ranking-fila__ventas-num {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1E88E5;
  line-height: 1;
}

.ranking-fila__ventas-label {
  font-size: 0.65rem;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ranking-estatus-btn {
  flex-shrink: 0;
  font-size: 0.75rem !important;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
}

.ranking-estatus-chip {
  font-weight: 600;
}

.ranking-estatus-chip--solo-lectura {
  pointer-events: none;
}
</style>
